<template>
  <div id="app">
    <div v-if="ambiente" class="ambiente noprint">
      <span class="ambiente-info" :class="ambientecor">{{ ambiente }} </span>
    </div>
    <router-view />
    <Toast />
    <ConfirmDialog />
  </div>
</template>

<script>
import Vue from 'vue'
import Moment from 'moment'
import events from '@/modules/events'
import Config from '@/config'

Vue.filter('formatarData', function (value) {
  if (
    value == null ||
    typeof value === 'undefined' ||
    value == '' ||
    value == 'Não Consta'
  ) {
    return '-'
  } else {
    return new Date(value).toLocaleDateString('pt-BR')
  }
})

Vue.filter('formatarDataPadraoAmericano', function (value) {
  if (
    value == null ||
    typeof value === 'undefined' ||
    value == '' ||
    value == 'Não Consta'
  ) {
    return '-'
  } else {
    if (JSON.stringify(value).includes('/')) {
      const dataFormatada = Moment(value, 'DD/MM/YYYY').toDate()
      return Moment(dataFormatada).format('YYYY-MM-DD')
    }
    return Moment(value).format('YYYY-MM-DD')
  }
})

Vue.filter('formatarValor', function (value) {
  if (value === null || typeof value === 'undefined' || value === '') {
    return '-'
  } else {
    return value.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    })
  }
})

Vue.filter('formatarValorSemCifrao', function (value) {
  if (value === null || typeof value === 'undefined' || value === '') {
    return '-'
  } else {
    const currencyFractionDigits = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'DOL',
    }).resolvedOptions().maximumFractionDigits

    return value.toLocaleString('en-US', {
      maximumFractionDigits: currencyFractionDigits,
    })
  }
})

Vue.filter('formatarSexo', function (value) {
  const sexoMap = {
    M: 'Masculino',
    F: 'Feminino',
    null: 'Não Consta',
    undefined: 'Não Consta',
    '': 'Não Consta',
  }
  return sexoMap[value] || 'Outro'
})

Vue.filter('formatarEstadoCivil', function (value) {
  const sexoMap = {
    C: 'Casado(a)',
    S: 'Solteiro(a)',
    D: 'Divorciado(a)',
    null: 'Não Consta',
    undefined: 'Não Consta',
    '': 'Não Consta',
  }
  return sexoMap[value] || 'Outro'
})

Vue.filter('formatarEntidade', function (value) {
  if (value == 'SEAD 1') {
    return 'Executivo'
  } else if (value == 'SEAD 2') {
    return 'PBPrev'
  } else {
    return value
  }
})

Vue.filter('limitadorString', function (value, tamanho = 20) {
  if (!value) return ''
  if (value.length > tamanho) {
    return value.substring(0, tamanho) + '...'
  }
  return value
})

Vue.filter('formataPorcentagem', function (value, tipoDocumento) {
  if (typeof value !== 'number' || value < 0 || value > 1) {
    return value
  }
  if ('PDF' === tipoDocumento.toUpperCase()) {
    return `${(value * 100).toFixed(0)}%`
  }
  return value.toFixed(1)
})

Vue.filter('mascaraCpf', function (value) {
  if (value) {
    let cpf = value?.replace(/[^\d]/g, '')
    return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
  }
  return ''
})

Vue.filter('mascaraCNPJ', function (value) {
  if (value) {
    let cnpj = new String(value)
    return cnpj.replace(
      /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
      '$1.$2.$3/$4-$5',
    )
  }
  return ''
})

Vue.mixin({
  methods: {
    verificaSubdomain: function () {
      const host = window.location.hostname
      const parts = host.split('.')
      let subdomain
      if (
        parts[0] === 'dev' ||
        parts[0] === 'teste' ||
        parts[0] === 'treinamento'
      ) {
        subdomain = parts[1]
      } else {
        subdomain = parts[0]
      }
      return subdomain
    },

    estaNoModuloGestao: function () {
      return this.verificaSubdomain() === 'gestao'
    },
    estaNoModuloConsignataria: function () {
      return this.verificaSubdomain() === 'consignataria'
    },
    estaNoModuloServidor: function () {
      return this.verificaSubdomain() === 'servidor'
    },
  },
})

export default {
  name: 'App',

  computed: {
    loading: () => events.loading,
    ambiente: () => {
      if (Config.ENV === 'production') return null
      return Config.ENV
    },
    ambientecor: () => {
      if (Config.ENV === 'development') return 'ambiente-desenvolvimento'
      if (Config.ENV === 'homolog') return 'ambiente-homologacao'
      if (Config.ENV === 'treinamento') return 'ambiente-treinamento'
      if (Config.ENV === 'teste') return 'ambiente-teste'
      return 'ambiente-padrao'
    },
    versao: () => {
      return Config.TAG_GIT
    },
    data_publicacao: () => {
      return Config.DATA_PUBLICACAO
    },
  },
}
</script>

<style lang="scss" scoped>
.logo {
  width: 100%;
  margin: auto;
  display: block;
}

.footer {
  background-color: #071d41;
  margin-top: 5%;
  width: 100vw;
}
.bar {
  background-color: #ffffff;
}

.logo {
  margin-left: 37px;
}

#app {
  min-height: 100vh;
}
.logo {
  z-index: 9999;
  position: fixed;
}
.ambiente-info {
  text-align: center;
  width: 100%;
  z-index: 9999;
  position: fixed;
  margin: 0 auto;
  font-size: 12px;
  text-transform: uppercase;
}

.ambiente-desenvolvimento {
  background: rgb(128, 1, 1);
  color: white;
}

.ambiente-homologacao {
  background: rgb(126, 126, 0);
  color: black;
}

.ambiente-teste {
  background: rgb(1, 1, 126);
  color: black;
}

.ambiente-treinamento {
  background: rgb(1, 126, 1);
  color: black;
}

.ambiente-padrao {
  background: rgb(0, 0, 0);
  color: white;
}

@media print {
  .noprint {
    display: none;
  }
}
</style>
